const state = {
    dateRange: '',
    formWeek: '',
    revNo: '01',
    exportInstructionsData: [
        ["說明", "MARK ●：代表該爐為新營廠區(GFM&PRESS)熱料。  △：代表該爐為高溫均質化≦      ≧", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, "★:柳營廠區(RF70&S350)熱料", null, null, null, null, null, "'6*mail　研發部(轉品檢,轉開發).貿易部 .copy to煉鋼(7).鍛造(2).物料倉", null, null, null, null, null, null, null, null, null, null, null, null, null,],
        ["illustrate", "Mark●：Means the furnace is into the hot furnace.   △：Means the furnace for high temperature homogenization≦     ≧    '6*mail　R & D(Turn seized goods, turn developed). Ministry of Trade. copy to Melting(7). Forging(2). Material warehouse", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        ["訂    單\n規    格\n要    求", "1、SR0218 630(G)　特殊化性：Cr = 16.00 ～ 17.50,Nb=0.15 ～ 0.45,Ta= < 0.05", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "2、SR0219 630PL Group 1　特殊化性：C=0.020 ～ 0.03,Mo= < 0.35,Ta= < 0.05", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "3、SR0223 630 Group 4　特殊化性：C=0.020 ～ 0.03", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "4、SR0229 630 Group 1　特殊化性：C=0.020 ～ 0.03", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "5、SR0232 416(G)　特殊化性：S=0.15 ～ 0.30", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "6、SR0233 1.4034　特殊化性：C=0.43 ～ .50,Cu= < 0.40,H= < 0.0002,N= < 0.0400,O= < 0.0080,P=0 ～ 0.040,S=0 ～ 0.015", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "7、SR0234 431Ni  特殊化性：Co=0 ～ 0.05,Cu= < 0.30,Nb= < 0.05,P= < 0.030,S= < 0.025,Sn=0 ～ 0.02,Ti= < 0.05,V=0 ～ 0.20,W=0 ～ 0.05", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "8、SR0238 422(G)　特殊化性：Al= < 0.025,Cu= < 0.15,Nb= < 0.05,P= < 0.025,Ti= < 0.025", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "9、SR0251 D2　特殊化性：Ni= < 0.30", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "10、SR0264 300M(V) 特殊化性 : P+S= < 0.025", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "11、SR0267 17CrNiMo6　特殊化性：H= < 0.00020,P=0 ～ 0.025", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "12、SR0272 4340(V)　特殊化性：C=0.41 ～ 0.430", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "13、SR0275　特殊化性：待MEMO", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "14、SR0280 S7 Group 1 特殊化性：Mn=0.60 ～ 0.75", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "15、SR0283 H11 Group 1 特殊化性：C=.36 ～ 0.41,Cu= < 0.30,H= < 0.0003,N= < 0.020,O= < 0.005", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "16、SR0284 H11 Group 1 特殊化性：Al= < 0.030,Cu= < 0.20,H2= < 0.0002,Ni= < 0.20,N= < 0.020,O= < 0.005", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "17、SR0285 H11 Group 1 特殊化性：C=.36 ～ 0.41,Cu= < 0.30,H= < 0.0003,N= < 0.020,O= < 0.005", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "18、SR0286 316L(R) 特殊化性：S=0.020 ～ 0.030", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "19、SR0288~SR0290 347H　特殊化性：Co=0 ～ 0.20,Cu=0 ～ 0.50,Mo=0 ～ 0.45,S=0 ～ 0.015", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, "",],
        ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "Sheet Rev：5", "",],
        [null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, "課長Section Chief：", null, null, null, null, null, null, null, null, "製表Tabulation：", null, null, null, null, null, null, null, null, "SOP：R10-001", null, null, null, null,],
        [null, "★鋼種轉換優先順序", null, null, null, null, "★GE相關鋼種：", null, null, null, "★賣鑄錠,包爐爐號", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "The steel kinds conversion priority", null, null, null, null, "Related steels", null, null, null, "Sell ingot, package Furnace No.", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "* D2(G) → DIN 1.2379", null, null, null, null, "403Cbplus(R),403Cb(R),", null, null, null, "不可澆鑄單雙支與分流支", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "* ED61(G) →DIN 1.2344", null, null, null, null, "410/403(R),422(R),", null, null, null, "Can not Casting for single , double and branch ingot.", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "* A2(G) →DIN 1.2363", null, null, null, null, "M152(R),GTD450(R )", null, null, null, "1.8070(M),1.2714不可澆注單雙支", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "* 440C(G) →AISI440C", null, null, null, null, null, null, null, null, "Can not Casting for single and double ingot.", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "* 304L(G) →AISI 304L", null, null, "* 316L(G) →AISI 316L", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
        [null, "* 431(G) →AISI 431", null, null, "* 410(G) →AISI 410", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,]
    ],
    exportMerge: [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 2 } },
        { s: { r: 0, c: 3 }, e: { r: 0, c: 35 } },
        { s: { r: 1, c: 3 }, e: { r: 1, c: 35 } },
        { s: { r: 2, c: 3 }, e: { r: 2, c: 35 } },
        { s: { r: 3, c: 0 }, e: { r: 3, c: 2 } },
        { s: { r: 3, c: 10 }, e: { r: 3, c: 11 } },
        { s: { r: 3, c: 37 }, e: { r: 3, c: 38 } },
        { s: { r: 4, c: 1 }, e: { r: 4, c: 3 } },
        { s: { r: 4, c: 4 }, e: { r: 4, c: 6 } },
        { s: { r: 4, c: 7 }, e: { r: 4, c: 9 } },
        { s: { r: 4, c: 10 }, e: { r: 4, c: 12 } },
        { s: { r: 4, c: 13 }, e: { r: 4, c: 15 } },
        { s: { r: 4, c: 16 }, e: { r: 4, c: 18 } },
        { s: { r: 4, c: 19 }, e: { r: 4, c: 21 } },
        { s: { r: 4, c: 22 }, e: { r: 4, c: 24 } },
        { s: { r: 4, c: 25 }, e: { r: 4, c: 27 } },
        { s: { r: 4, c: 28 }, e: { r: 4, c: 30 } },
        { s: { r: 4, c: 31 }, e: { r: 4, c: 33 } },
        { s: { r: 4, c: 34 }, e: { r: 4, c: 36 } },
        { s: { r: 4, c: 37 }, e: { r: 4, c: 38 } },
        { s: { r: 6, c: 37 }, e: { r: 7, c: 37 } },
        { s: { r: 6, c: 38 }, e: { r: 7, c: 38 } },
        { s: { r: 8, c: 37 }, e: { r: 10, c: 37 } },
        { s: { r: 8, c: 38 }, e: { r: 10, c: 38 } },
        { s: { r: 11, c: 37 }, e: { r: 13, c: 37 } },
        { s: { r: 11, c: 38 }, e: { r: 13, c: 38 } },
        { s: { r: 14, c: 37 }, e: { r: 16, c: 37 } },
        { s: { r: 14, c: 38 }, e: { r: 16, c: 38 } },
        { s: { r: 17, c: 37 }, e: { r: 19, c: 37 } },
        { s: { r: 17, c: 38 }, e: { r: 19, c: 38 } },
        { s: { r: 20, c: 37 }, e: { r: 22, c: 37 } },
        { s: { r: 20, c: 38 }, e: { r: 22, c: 38 } },
        { s: { r: 23, c: 37 }, e: { r: 25, c: 37 } },
        { s: { r: 23, c: 38 }, e: { r: 25, c: 38 } },
        { s: { r: 26, c: 1 }, e: { r: 26, c: 18 } },
        { s: { r: 26, c: 19 }, e: { r: 26, c: 24 } },
        { s: { r: 26, c: 25 }, e: { r: 26, c: 38 } },
        { s: { r: 27, c: 1 }, e: { r: 27, c: 38 } },
        { s: { r: 28, c: 1 }, e: { r: 28, c: 38 } },
        { s: { r: 29, c: 1 }, e: { r: 29, c: 38 } },
        { s: { r: 30, c: 1 }, e: { r: 30, c: 38 } },
        { s: { r: 31, c: 1 }, e: { r: 31, c: 38 } },
        { s: { r: 32, c: 1 }, e: { r: 32, c: 38 } },
        { s: { r: 33, c: 1 }, e: { r: 33, c: 38 } },
        { s: { r: 34, c: 1 }, e: { r: 34, c: 38 } },
        { s: { r: 35, c: 1 }, e: { r: 35, c: 38 } },
        { s: { r: 36, c: 1 }, e: { r: 36, c: 38 } },
        { s: { r: 37, c: 1 }, e: { r: 37, c: 38 } },
        { s: { r: 38, c: 1 }, e: { r: 38, c: 38 } },
        { s: { r: 39, c: 1 }, e: { r: 39, c: 38 } },
        { s: { r: 40, c: 1 }, e: { r: 40, c: 38 } },
        { s: { r: 41, c: 1 }, e: { r: 41, c: 38 } },
        { s: { r: 42, c: 1 }, e: { r: 42, c: 38 } },
        { s: { r: 43, c: 1 }, e: { r: 43, c: 38 } },
        { s: { r: 44, c: 1 }, e: { r: 44, c: 38 } },
        { s: { r: 45, c: 1 }, e: { r: 45, c: 38 } },
        { s: { r: 46, c: 1 }, e: { r: 46, c: 38 } },
        { s: { r: 28, c: 0 }, e: { r: 48, c: 0 } },
        { s: { r: 48, c: 37 }, e: { r: 48, c: 38 } },
    ],
    exportCol: [
        { wch: 9.4 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 7 },
        { wch: 7 },
    ],
    exportExcelStyle: {
        R: {
            4: {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            7: {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            10: {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            13: {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            16: {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            19: {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            22: {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            26: {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            27: {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            48: {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
        },
        detail: {
            "0-3": {
                alignment: {
                    horizontal: "center",
                    vertical: "center",
                },
            },
            "1-3": {
                alignment: {
                    horizontal: "center",
                    vertical: "center",
                },
            },
            "2-3": {
                alignment: {
                    horizontal: "center",
                    vertical: "center",
                },
            },
            "4-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "4-1": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
            },
            "4-4": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "4-7": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "4-10": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "4-13": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "4-16": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "4-19": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "4-22": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "4-25": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "4-28": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "4-31": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "4-34": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "4-37": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "4-38": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "5-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "5-4": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "5-7": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "5-10": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "5-13": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "5-16": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "5-19": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "5-22": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "5-25": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "5-28": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "5-31": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "5-34": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "5-37": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "5-38": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "6-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "6-4": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "6-7": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "6-10": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "6-13": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "6-16": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "6-19": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "6-22": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "6-25": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "6-28": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "6-31": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "6-34": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "6-37": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "6-38": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "7-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "7-4": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "7-7": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "7-10": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "7-13": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "7-16": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "7-19": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "7-22": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "7-25": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "7-28": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "7-31": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "7-34": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "7-37": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "7-38": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "8-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "8-4": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "8-7": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "8-10": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "8-13": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "8-16": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "8-19": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "8-22": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "8-25": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "8-28": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "8-31": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "8-34": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "8-37": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "8-38": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "9-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "9-4": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "9-7": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "9-10": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "9-13": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "9-16": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "9-19": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "9-22": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "9-25": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "9-28": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "9-31": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "9-34": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "9-37": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "9-38": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "10-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "10-4": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "10-7": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "10-10": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "10-13": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "10-16": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "10-19": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "10-22": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "10-25": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "10-28": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "10-31": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "10-34": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "10-37": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "10-38": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "11-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "11-4": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "11-7": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "11-10": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "11-13": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "11-16": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "11-19": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "11-22": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "11-25": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "11-28": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "11-31": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "11-34": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "11-37": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "11-38": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "12-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "12-4": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "12-7": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "12-10": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "12-13": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "12-16": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "12-19": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "12-22": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "12-25": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "12-28": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "12-31": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "12-34": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "12-37": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "12-38": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "13-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "13-4": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "13-7": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "13-10": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "13-13": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "13-16": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "13-19": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "13-22": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "13-25": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "13-28": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "13-31": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "13-34": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "13-37": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "13-38": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "14-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "14-4": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "14-7": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "14-10": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "14-13": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "14-16": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "14-19": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "14-22": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "14-25": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "14-28": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "14-31": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "14-34": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "14-37": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "14-38": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "15-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "15-4": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "15-7": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "15-10": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "15-13": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "15-16": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "15-19": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "15-22": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "15-25": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "15-28": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "15-31": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "15-34": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "15-37": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "15-38": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "16-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "16-4": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "16-7": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "16-10": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "16-13": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "16-16": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "16-19": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "16-22": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "16-25": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "16-28": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "16-31": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "16-34": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "16-37": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "16-38": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "17-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "17-4": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "17-7": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "17-10": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "17-13": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "17-16": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "17-19": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "17-22": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "17-25": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "17-28": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "17-31": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "17-34": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "17-37": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "17-38": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "18-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "18-4": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "18-7": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "18-10": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "18-13": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "18-16": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "18-19": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "18-22": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "18-25": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "18-28": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "18-31": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "18-34": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "18-37": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "18-38": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "19-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "19-4": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "19-7": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "19-10": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "19-13": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "19-16": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "19-19": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "19-22": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "19-25": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "19-28": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "19-31": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "19-34": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "19-37": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "19-38": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "20-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "20-4": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "20-7": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "20-10": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "20-13": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "20-16": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "20-19": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "20-22": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "20-25": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "20-28": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "20-31": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "20-34": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "20-37": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "20-38": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "21-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "21-4": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "21-7": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "21-10": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "21-13": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "21-16": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "21-19": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "21-22": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "21-25": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "21-28": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "21-31": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "21-34": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "21-37": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "21-38": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "22-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "22-4": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "22-7": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "22-10": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "22-13": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "22-16": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "22-19": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "22-22": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "22-25": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "22-28": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "22-31": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "22-34": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "22-37": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "22-38": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "23-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "23-4": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "23-7": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "23-10": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "23-13": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "23-16": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "23-19": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "23-22": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "23-25": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "23-28": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "23-31": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "23-34": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "23-37": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "23-38": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "24-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "24-4": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "24-7": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "24-10": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "24-13": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "24-16": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "24-19": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "24-22": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "24-25": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "24-28": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "24-31": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "24-34": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "24-37": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "24-38": {
                border: {
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "25-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "25-4": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "25-7": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "25-10": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "25-13": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "25-16": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "25-19": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "25-22": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "25-25": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "25-28": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "25-31": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "25-34": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "25-37": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "25-38": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "26-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "26-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "26-1": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "27-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "27-38": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "28-0": {
                alignment: {
                    wrapText: true,
                    horizontal: "center",
                    vertical: "center",
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
                // font: {
                //   name: "標楷體",
                //   color: { rgb: "4b8c80" },
                // },
                // fill: {
                //   fgColor: { rgb: "e5f7ed" },
                // },
            },
            "28-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "29-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "29-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "30-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "30-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "31-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "31-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "32-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "32-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "33-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "33-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "34-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "34-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "35-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "35-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "36-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "36-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "37-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "37-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "38-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "38-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "39-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "39-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "40-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "40-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "41-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "41-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "42-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "42-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "43-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "43-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "44-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "44-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "45-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "45-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "46-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "46-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "47-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "47-38": {
                border: {
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "48-0": {
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
            "48-38": {
                border: {
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            },
        },
    },
};

const getters = {
    get_exportTitleData: (state) => {
        var exportTitleData = [
            ["附件Attachment 5. ", null, null, "榮　剛　材　料　科　技　股　份　有　限　公　司", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
            [null, null, null, "35　噸　爐　熔　煉　週　生　產　計　劃", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
            [null, null, null, "35 ton furnace melting weekly production plan", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,],
            [`日期Date：${state.dateRange}`, null, null, null, null, null, null, null, null, null, `週次(Week No)：${state.formWeek}`, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, `REV NO：${state.revNo}`, null,],
            ["爐次Heats", "1", null, null, "2", null, null, "3", null, null, "4", null, null, "5", null, null, "6", null, null, "7", null, null, "8", null, null, "9", null, null, "10", null, null, "11", null, null, "12", null, null, "鍛機鍛模順序", null,],
        ];
        return exportTitleData;
    },
    get_exportInstructionsData: (state) => {
        return state.exportInstructionsData;
    },
    get_exportMerge: (state) => {
        return state.exportMerge;
    },
    get_exportCol: (state) => {
        return state.exportCol;
    },
    get_exportExcelStyle: (state) => {
        return state.exportExcelStyle;
    },
};
const actions = {
    set_dateRange(context, string) {
        context.commit("SET_DATERANGE", string);
    },
    set_formWeek(context, string) {
        context.commit("SET_FORMWEEK", string);
    },
    set_revNo(context, string) {
        context.commit("SET_REVNO", string);
    },
};
const mutations = {
    SET_DATERANGE(state, string) {
        state.dateRange = string;
    },
    SET_FORMWEEK(state, string) {
        state.formWeek = string;
    },
    SET_REVNO(state, string) {
        state.revNo = string;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
